import { Badge } from '#/shared/ui/badge'
import type { BadgeVariant } from '#/shared/ui/badge'

const META_SEPARATOR = ' · '

interface PaymentSummaryProps {
  typeLabel: string
  flowLabel: string
  flowVariant: BadgeVariant
  amount: string
  metaParts: ReadonlyArray<string>
}

export function PaymentSummary({
  typeLabel,
  flowLabel,
  flowVariant,
  amount,
  metaParts,
}: PaymentSummaryProps) {
  const meta = metaParts.filter(Boolean).join(META_SEPARATOR)
  return (
    <div className="flex w-full items-start justify-between gap-3 rounded-md bg-gray-50 px-3.75 py-2.5">
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-semibold text-gray-900">
            {typeLabel}
          </span>
          <Badge
            variant={flowVariant}
            className="h-auto rounded px-1.5 py-0.5 text-xs font-normal"
          >
            {flowLabel}
          </Badge>
        </div>
        <span className="text-xs text-gray-500">{meta}</span>
      </div>
      <span className="text-base font-semibold text-gray-900">{amount}</span>
    </div>
  )
}
